import React from 'react';
import FormField from '@cloudscape-design/components/form-field';
import Select, { SelectProps } from '@cloudscape-design/components/select';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';
import Box from '@cloudscape-design/components/box';
import Link from '@cloudscape-design/components/link';
import SpaceBetween from '@cloudscape-design/components/space-between';

interface Props {
  pipelines: string[];
  selected: string;
  onSelect: (p: string) => void;
  onRequestClick?: () => void;
  onViewRequestsClick?: () => void;
}

export const PipelineSelector: React.FC<Props> = ({ pipelines, selected, onSelect, onRequestClick, onViewRequestsClick }) => {
  const options: SelectProps.Option[] = pipelines.map(p => ({
    label: p,
    value: p,
  }));
  const selectedOption = selected ? { label: selected, value: selected } : null;

  return (
    <Container
      header={
        <Header variant="h2" description="Pick a pipeline to analyze its missing business metrics">
          Select pipeline
        </Header>
      }
    >
      <SpaceBetween size="m">
        {onRequestClick && (
          <Box fontSize="body-s">
            <SpaceBetween size="xs" direction="horizontal">
              <Link onFollow={(e) => { e.preventDefault(); onRequestClick(); }}>
                Your pipeline not listed? Submit a request 📩
              </Link>
              {onViewRequestsClick && (
                <Link onFollow={(e) => { e.preventDefault(); onViewRequestsClick(); }}>
                  | View all requests 📋
                </Link>
              )}
            </SpaceBetween>
          </Box>
        )}
        <FormField label="Pipeline / Service" stretch>
          <Select
            selectedOption={selectedOption}
            onChange={({ detail }) => onSelect(detail.selectedOption.value || '')}
            options={options}
            placeholder="Choose a pipeline..."
            filteringType="auto"
            filteringPlaceholder="Type to filter pipelines"
            expandToViewport
          />
        </FormField>
      </SpaceBetween>
    </Container>
  );
};
